import { ChevronLeft, ChevronRight } from "lucide-react";

interface NavigationBarProps {
  isFirst: boolean;
  isLast: boolean;
  isNextDisabled?: boolean;
  currentLabel?: string;
  onPrevious: () => void;
  onNext: () => void;
}

export function NavigationBar({
  isFirst,
  isLast,
  isNextDisabled,
  currentLabel,
  onPrevious,
  onNext,
}: NavigationBarProps) {
  const nextDisabled = isNextDisabled ?? isLast;
  return (
    <div className="bg-white border-t border-gray-200 px-6 py-4">
      <div className="max-w-6xl mx-auto flex justify-between items-center">
        <button
          onClick={onPrevious}
          disabled={isFirst}
          className="px-4 py-2 text-sm text-gray-700 hover:text-gray-900 disabled:text-gray-400 disabled:cursor-not-allowed flex items-center gap-2"
        >
          <ChevronLeft className="w-4 h-4" /> Previous
        </button>
        {currentLabel && (
          <div className="text-xs text-gray-500">{currentLabel}</div>
        )}
        <button
          onClick={onNext}
          disabled={nextDisabled}
          className={`px-4 py-2 text-sm rounded-lg flex items-center gap-2 transition ${nextDisabled
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-primary hover:bg-primary-hover hover:text-on-primary text-on-primary"
            }`}
        >
          Next
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

export default NavigationBar;
